import { useCallback, useEffect, useState } from "react";
import s from "./video-row.module.scss";
import { queryClient } from "@shared/api/query-client";
import { IconCamera } from "@tabler/icons-react";
import { SettingRow } from "../setting-row/setting-row";
import { useDropzone } from "react-dropzone";
import classNames from "classnames";
import { Button } from "@shared/ui/button/button";
import { toast } from "react-toastify";
import { useAttachFileModal } from "@features/attach-files";
import { useRemoveVideoPresentation } from "@entities/profile/api/useRemoveVideoPresentation";

export const VideoRow = ({localVideo, setLocalVideo}) => {
	const { data: profile } = queryClient.getQueryData(["profile"]);
	const {mutate: remove} = useRemoveVideoPresentation()
	const { open: openAttachFileModal } = useAttachFileModal();
	
  const [videoUrl, setVideoUrl] = useState('');
  const [error, setError] = useState('');
	const [hasVideo, setHasVideo] = useState(!!videoUrl || !!profile?.video_presentation)
	
	useEffect(() => {
		setHasVideo(!!videoUrl || !!profile?.video_presentation)
	}, [localVideo, profile, videoUrl])
	
	useEffect(() => {
		if(!localVideo){
			setVideoUrl('')
		}
	}, [localVideo])

	const applyVideoFile = useCallback((file) => {
		if (!file) return;
		// Очищаем предыдущие URL
		if (videoUrl) URL.revokeObjectURL(videoUrl);

		const url = URL.createObjectURL(file);
		setVideoUrl(url);
		setLocalVideo(file);
		setError('');
	}, [videoUrl, setLocalVideo]);

  const onDrop = useCallback(async (acceptedFiles, rejectedFiles) => {
    setError('');

    if (rejectedFiles?.length > 0) {			
      setError('Пожалуйста, выберите только один видео файл');
      return;
    }

    const file = acceptedFiles[0];
    if (file && file.type.startsWith('video/')) {
      applyVideoFile(file);
    }
  }, [applyVideoFile])

	const handleSelect = useCallback(async (items) => {
		const item = items?.[0];
		if (!item) return;

		if (item instanceof File) {
			applyVideoFile(item);
			return;
		}

		// Видео из «Моих файлов» — забираем бинарник с хранилища в File,
		// т.к. attach-эндпоинт принимает только multipart
		try {
			const response = await fetch(`${process.env.REACT_APP_STORAGE_URL}${item.file}`);
			if (!response.ok) throw new Error();
			const blob = await response.blob();
			applyVideoFile(new File([blob], item.name || 'video.mp4', { type: blob.type || 'video/mp4' }));
		} catch {
			toast.error('Не удалось загрузить видео из «Моих файлов»');
		}
	}, [applyVideoFile]);

	const openFileManager = () => {
		openAttachFileModal({
			multiple: false,
			maxFiles: 1,
			onlyCategory: 'video',
			onSelect: handleSelect,
		});
	};

	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		accept: {
			'video/*': ['.mp4', '.mov', '.ogg']
		},
		maxFiles: 1,
		onDrop,
		multiple: false,
		noClick: true,
		noKeyboard: true,
	});

  const removeVideo = () => {
		remove()
  };

	const cancelVideo = () => {
		setLocalVideo(null);
		setVideoUrl(null)
    setError('');
	}

  return (
    <SettingRow
      title="Ваше видео"
      subtitle="Здесь вы можете добавить свое видео"
    >
        <div className={s.assetsWrapper} {...getRootProps()}>
          <div className={s.teacherAvatar}>
						<input {...getInputProps()} />
						<button type="button" className={classNames(s.edit, !hasVideo && s.active)} onClick={openFileManager}>
              <IconCamera size={24} color="#fff" />
							{isDragActive ? 'Отпустите видео здесь' : 'Добавить видео'}
            </button>
						{hasVideo ? <video
							src={videoUrl || process.env.REACT_APP_STORAGE_URL + profile?.video_presentation}
							controls={false}
							autoPlay={false}
						/> : <div className={s.empty}></div> }
          </div>
					<div className={s.textWrapper}>
					 {error && (
							<div className={s.error}>
								{error}
							</div>
						)}
						<div className={s.title}>
							+15% к охвату учеников
						</div>
						<div className={s.description}>
							В среднем получают преподаватели с видео
						</div>
						{(!!profile?.video_presentation && !localVideo) && <Button size="small" onClick={removeVideo} label="Удалить видео" className={s.removeButton}/>}
						{!!localVideo && <Button size="small" onClick={cancelVideo} label="Отменить" className={s.removeButton}/>}
					</div>

        </div>
    </SettingRow>
  );
};
